import { createDecorator } from 'vue-class-component'
import { snakeCase, debounce as _debounce, throttle as _throttle } from 'lodash'

export function DtWatch(path, options = {}) {
  const { deep = false, immediate = false } = options

  return createDecorator((componentOptions, handler) => {
    if (typeof componentOptions._dt_watches !== 'object') {
      componentOptions._dt_watches = Object.create(null)
    }
    const watch = componentOptions._dt_watches

    watch[path] = { handler, deep, immediate }
  })
}

export const DtHooks = createDecorator((componentOptions, key) => {
  if (typeof componentOptions._dt_hooks !== 'object') {
    componentOptions._dt_hooks = Object.create(null)
  }

  const hooks = componentOptions._dt_hooks

  hooks[snakeCase(key).replace(/^dt_/, '')] = componentOptions.methods[key]
})

export const NoCache = createDecorator((componentOptions, key) => {
  componentOptions.computed[key].cache = false
})

export function Debounce(wait = 100, options = {}) {
  return (target, name, descriptor) => {
    descriptor.value = _debounce(descriptor.value, wait, options)
    return descriptor
  }
}

export function Throttle(wait = 100, options = {}) {
  return (target, name, descriptor) => {
    descriptor.value = _throttle(descriptor.value, wait, options)
    return descriptor
  }
}
